export default __webpack_public_path__ + "static/swash-1-21fab494221790a4c5f9882cf580d4c2.png";